var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',{attrs:{"no-gutters":""}},[(_vm.selectedLogType === 'sessions')?_c('reports-sessions'):_vm._e(),(_vm.selectedLogType === 'tools')?_c('reports-tools'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }